import { KPI_LEVELS } from '../../constants';
import styles from '../Cells.pcss';
export const getKpiLevelClass = (status)=>{
    switch(status){
        case KPI_LEVELS.LOW:
            return styles.kpiCell_low;
        case KPI_LEVELS.HIGH:
            return styles.kpiCell_high;
        case KPI_LEVELS.TARGET:
            return styles.kpiCell_target;
        default:
            return styles.kpiCell_neutral;
    }
};
